import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import React, { useEffect, useRef, useState } from 'react'
import { yellowImg } from "../Utils/Index";
import ModelView from './ModelView'
import * as  THREE from "three";
import { Canvas } from '@react-three/fiber';
import { View } from "@react-three/drei";
import { models, sizes } from '../Constants/Index';
import { animateWithGsapTimeline } from '../Utils/animation';

const Model = () => {
  const [size, setSize] = useState('small')
  const [model, setModel] = useState({
    title: 'Iphone 15 Pro in Natural Titanium',
    color: ['#8F8A81', '#FFE7B9', '#6F6C64'],
    img: yellowImg
  })

  // camera controll model
  const cameraControlSmall = useRef()
  const cameraControlLarge = useRef()

  // model
  const small = useRef(new THREE.Group())
  const large = useRef(new THREE.Group())

  // rotation 
  const [smallRotation, setSmallRotation] = useState(0)
  const [largeRotation, setLargeRotation] = useState(0)

  const timeline = gsap.timeline()

  useEffect(() => {
    if (size === 'large') {
      animateWithGsapTimeline(timeline, small, smallRotation, '#view1', '#view2', {
        transform: 'translateX(-100%)',
        duration: 2,
      })
    }
    if (size === 'small') {
      animateWithGsapTimeline(timeline, large, largeRotation, '#view2', '#view1', {
        transform: 'translateX(0%)',
        duration: 2,
      })
    }
  }, [size])


  useGSAP(() => {
    gsap.to('#heading', {
      opacity: 1,
      y: 0,
      delay: .4,
      scrollTrigger: {
        trigger: '#heading',
        toggleActions: "restart none none none",
      }
    })
  }, [])
  return (
    <section className='sm:py-32 py-20 sm:px-10 px-5'>
      <div className='screen-max-width'>
        <h1 id="heading" className='text-gray lg:text-6xl md:text-5xl text-3xl lg:mb-0 mb-5 font-medium opacity-0 translate-y-20'>
          Take a closer look
        </h1>

        <div className='flex flex-col items-center mt-5'>
          <div className='w-full h-[75vh] md:h[90vh] overflow-hidden relative'>
            <ModelView
              index={1}
              groupRef={small}
              gsapType='view1'
              controlRef={cameraControlSmall}
              setRotation={setSmallRotation}
              item={model}
              size={size}

            />
            <ModelView
              index={2}
              groupRef={large}
              gsapType='view2'
              controlRef={cameraControlLarge}
              setRotation={setLargeRotation}
              item={model}
              size={size}
            />

            <Canvas
              className='w-full h-full'
              style={{
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                overflow: 'hidden'
              }}
              eventSource={document.getElementById('root')}
            >
              <View.Port />
            </Canvas>
          </div>

          <div className='mx-auto w-full'>
            <p className='text-sm font-light mb-5 text-center'>{model.title}</p>
            <div className='flex items-center justify-center '>
              <ul className='color-container'>
                {
                  models.map((item, i) => (
                    <li
                      key={i}
                      className='w-6 h-6 rounded-full mx-2 cursor-pointer'
                      style={{ backgroundColor: item.color[0] }}
                      onClick={() => setModel(item)}
                    />
                  ))
                }
              </ul>

              <button className='size-btn-container'>
                {
                  sizes.map(({ label, value }) => (
                    <span
                      className='size-btn'
                      key={label}
                      style={{ backgroundColor: size === value ? 'white' : 'transparent', color: size === value ? 'black' : 'white' }}
                      onClick={() => setSize(value)}
                    >
                      {label}
                    </span>
                  ))
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Model